export default __webpack_public_path__ + "static/media/file-ok.78c9bc6e.svg";